import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Clock } from 'lucide-react';
import { companyInfo, openingHours } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Produits',
      links: [
        { label: 'Ordinateurs', href: '#boutique' },
        { label: 'Smartphones', href: '#boutique' },
        { label: 'Tablettes', href: '#boutique' },
        { label: 'Vidéosurveillance', href: '#boutique' }
      ]
    },
    {
      title: 'Services',
      links: [
        { label: 'Réparation PC', href: '#services' },
        { label: 'Installation domicile', href: '#services' },
        { label: 'Assistance gratuite', href: '#services' },
        { label: 'Transfert données', href: '#services' }
      ]
    }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div>
            <img
              src={companyInfo.logoUrl}
              alt="CLIC58"
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Votre boutique informatique de proximité à Corbigny. Vente, réparation et accompagnement personnalisé.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <a
                href={`tel:${companyInfo.phone.replace(/\./g, '')}`}
                className="flex items-center gap-3 text-gray-400 hover:text-primary-cyan transition-colors"
              >
                <Phone className="w-5 h-5" />
                {companyInfo.phone}
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-3 text-gray-400 hover:text-primary-cyan transition-colors"
              >
                <Mail className="w-5 h-5" />
                {companyInfo.email}
              </a>
              <a
                href={companyInfo.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 text-gray-400 hover:text-primary-cyan transition-colors"
              >
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>{companyInfo.address}</span>
              </a>
            </div>
          </div>

          {/* Links Columns */}
          {footerLinks.map((column, index) => (
            <div key={index}>
              <h4 className="text-white font-semibold text-lg mb-6">{column.title}</h4>
              <ul className="space-y-3">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-primary-cyan transition-colors duration-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Opening Hours */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-6 flex items-center gap-2">
              <Clock className="w-5 h-5 text-primary-cyan" />
              Horaires
            </h4>
            <ul className="space-y-2">
              {openingHours.map((item, index) => (
                <li key={index} className="flex justify-between text-sm">
                  <span className="text-gray-400">{item.day}</span>
                  <span className={item.isClosed ? 'text-red-400' : 'text-gray-300'}>
                    {item.hours}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} {companyInfo.name}. Tous droits réservés.
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/clic58"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-blue transition-colors duration-200"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-blue transition-colors duration-200"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
